import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { formatCentsAsDollars, formatShortDate } from "@lending/utils/formatters";
import { useApplicationHref } from "./applicationHelpers";
import styles from "../LoanPortalDashboard.module.css";
import type { LoanPortalApplication } from "../types";

/** A row in the "Things need your attention" card. */
export function AttentionRow({ application }: { application: LoanPortalApplication }) {
  const { l10n } = useLocalization();

  const title = l10n.getString(
    "loan-portal-continue-application",
    null,
    "Continue your application"
  );

  const dateLabel = l10n.getString("loan-portal-started-on", null, "Started");

  const actionLabel = l10n.getString("loan-portal-action-resume", null, "Resume");

  const href = useApplicationHref(application);

  return (
    <div className={styles.attentionRow}>
      <div className={styles.attentionRowIcon}>
        <span className="narmi-icon-file-text1" aria-hidden="true" />
      </div>
      <div className={styles.attentionRowBody}>
        <div className={styles.attentionRowTitle}>{title}</div>
        <div className={styles.attentionRowMeta}>
          {application.amountCents !== null &&
            `${formatCentsAsDollars(application.amountCents)} · `}
          {l10n.getString(
            "loan-portal-application-id",
            { id: application.displayId },
            `ID #${application.displayId}`
          )}{" "}
          &middot; {dateLabel} {formatShortDate(application.createdAt)}
        </div>
      </div>
      <span className={styles.desktopAttentionAction}>
        <Button as="a" href={href} kind="secondary" label={actionLabel} endIcon="arrow-right" />
      </span>
      <a className={styles.mobileAttentionAction} href={href} aria-label={actionLabel}>
        <span className="narmi-icon-arrow-right" aria-hidden="true" />
      </a>
    </div>
  );
}
